import { memo, useEffect, useRef } from 'react';
import { useFranchise } from '~/shared/utils';

type ViabillPricetagProps = {
    price: number;
    variant?: 'product' | 'list' | 'checkout' | 'basket';
};

const ViabillPricetagComponent = ({ price, variant = 'product' }: ViabillPricetagProps) => {
    const { activeMarket } = useFranchise();
    const containerRef = useRef<HTMLDivElement>(null);
    const { currency, countryKey, language } = activeMarket || {};

    // The ViaBill script replaces the pricetag node with its own, so the node must live outside
    // React's reconciliation — otherwise React fails with "removeChild" when it later unmounts it.
    useEffect(() => {
        const container = containerRef.current;
        if (!container) {
            return;
        }

        const pricetag = document.createElement('div');
        pricetag.className = 'viabill-pricetag';
        pricetag.dataset.view = variant;
        pricetag.dataset.price = String(price);
        if (currency) pricetag.dataset.currency = currency;
        if (countryKey) pricetag.dataset.countryCode = countryKey;
        if (language) pricetag.dataset.language = language;

        container.replaceChildren(pricetag);

        return () => container.replaceChildren();
    }, [price, variant, currency, countryKey, language]);

    return <div ref={containerRef} />;
};

export const ViabillPricetag = memo(ViabillPricetagComponent);
ViabillPricetag.displayName = 'ViabillPricetag';
